"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports._SectionHeader = void 0;

var _core = require("@emotion/core");

var _react = _interopRequireDefault(require("react"));

var _recompose = require("recompose");

var _emotion = require("@rebass/grid/emotion");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _SectionHeader = function _SectionHeader(_ref) {
  var children = _ref.children;
  return (0, _core.jsx)(_emotion.Flex, {
    justifyContent: "space-between",
    alignItems: "flex-start",
    flexWrap: "wrap"
  }, _react.default.Children.map(children, function (child) {
    return child && (0, _core.jsx)(_emotion.Box, null, _react.default.cloneElement(child));
  }));
};

exports._SectionHeader = _SectionHeader;

var _default = (0, _recompose.compose)((0, _recompose.setPropTypes)({
  children: function children(props) {
    return props.children.length > 2 && new Error('Please provide up to 2 children elements');
  }
}), (0, _recompose.setDisplayName)('SectionHeader'))(_SectionHeader);

exports.default = _default;